<template>
  <b-modal
    id="allocatevendor"
    size="xl"
    centered
    hide-footer
    hide-header
    :visible="showAllocateVendor"
    no-close-on-backdrop
    @hidden="closeModal"
  >
    <div class="p-3 d-flex align-items-center justify-content-between">
      <div class="b-modal-header">Allocate</div>
      <div @click="closeModal" class="pointer">
        <img
          class="rotate-on-hover"
          src="../../../assets/img/accessconnew/blueCross.svg"
          alt=""
        />
      </div>
    </div>
    <hr class="m-0" />
    <div class="p-3 d-flex align-items-center justify-content-between">
      <div class="pff-modal-heading">Vendor</div>
      <div class="d-flex">
        <div class="tp-bluetxt mr-4">
          Selected Vendors:&nbsp;{{ vendorSelected.length }}
        </div>
      </div>
    </div>
    <hr class="m-0" />
    <div class="d-flex justify-content-between align-items-center w-100 p-3">
      <div class="relativeclass teams-innerInputField w-75">
        <img
          class="teams-setImage"
          src="../../../assets/img/search-bar-icon.svg"
          alt=""
        />

        <b-form-input
          class="search-input"
          type="search"
          v-model.trim="searchQuery"
          debounce="500"
          @update="getVendors"
          placeholder="Search Vendor"
        >
        </b-form-input>
      </div>
    </div>
    <hr class="m-0" />

    <b-overlay :show="showVendorLoader" rounded="sm">
      <div class="p-3">
        <div class="kanban-exc-main-table">
          <div class="exc-table-head">
            <div class="common-single-checkbox pl-3" style="width: 5%">
              <b-form-checkbox
                v-model="selectAllChecked"
                @change="selectAllVendors"
              >
              </b-form-checkbox>
            </div>
            <div style="width: 35%">
              <span class="mr-2">User name</span>
              <template v-if="sortBy == 'name'">
                <img
                  @click="(sortBy = 'name'), (order = -1), getVendors()"
                  v-if="order === 1"
                  class="pointer"
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="order === -1"
                  @click="(sortBy = 'name'), (order = 1), getVendors()"
                  class="pointer"
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="(sortBy = 'name'), (order = 1), getVendors()"
                class="pointer img-h"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 30%">
              <span class="mr-2">Email</span>
              <template v-if="sortBy == 'email'">
                <img
                  @click="(sortBy = 'email'), (order = -1), getVendors()"
                  v-if="order === 1"
                  class="pointer"
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="order === -1"
                  @click="(sortBy = 'email'), (order = 1), getVendors()"
                  class="pointer"
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="(sortBy = 'email'), (order = 1), getVendors()"
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 30%">
              <span class="mr-2">Location</span>
              <template v-if="sortBy == 'customFields.Location'">
                <img
                  @click="
                    (sortBy = 'customFields.Location'),
                      (order = -1),
                      getVendors()
                  "
                  v-if="order === 1"
                  class="pointer"
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  @click="
                    (sortBy = 'customFields.Location'),
                      (order = 1),
                      getVendors()
                  "
                  v-if="order === -1"
                  class="pointer"
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="
                  (sortBy = 'customFields.Location'), (order = 1), getVendors()
                "
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
          </div>

          <div class="vendor-exc-table-body" id="top1">
            <div
              v-if="!showVendorLoader && vendorData && vendorData.length == 0"
              class="h-100"
            >
              <div
                v-if="
                  vendorData && vendorData.length === 0 && searchQuery == ''
                "
                class="
                  d-flex
                  align-items-center
                  flex-column
                  justify-content-center
                  h-100
                "
              >
                <div>
                  <img
                    src="../../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt=""
                  />
                </div>
                <div class="mt-2 text-center access-font-color">
                  No records found.
                </div>
              </div>
              <div
                v-else-if="
                  vendorData.length === 0 &&
                  searchQuery !== '' &&
                  !showVendorLoader
                "
                class="
                  d-flex
                  align-items-center
                  flex-column
                  justify-content-center
                  h-100
                "
              >
                <div>
                  <img
                    src="../../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt=""
                  />
                </div>
                <div class="mt-2 text-center access-font-color">
                  No matching results for &nbsp;
                  <span class="access-font-color-b text-center"
                    >"{{ searchQuery }}"</span
                  >.
                </div>
              </div>
            </div>
            <div>
              <div
                :style="{
                  background: isSelected(vendor) ? '#e1eef7' : '',
                }"
                class="
                  kanban-exc-table-row
                  mt-3
                  d-flex
                  justify-content-between
                  align-items-center
                  position-relative
                "
                v-for="vendor in vendorData"
                :key="vendor.vendorID"
              >
                <div class="kanban-tp-blueline"></div>
                <div
                  class="pl-1 d-flex justify-content-between align-items-center"
                >
                  <div class="common-single-checkbox" style="width: 5%">
                    <b-form-checkbox
                      :value="{
                        vendorID: vendor.vendorID,
                        vendorUserID: vendor.vendorUserID,
                        email: vendor.email,
                        name: vendor.name,
                      }"
                      v-model="vendorSelected"
                      @change="updateSelectAllStatus"
                    >
                    </b-form-checkbox>
                  </div>
                </div>

                <div
                  style="width: 35%"
                  class="d-flex align-items-center text-truncate pr-1"
                >
                  <img
                    src="../../../assets/img/newvendorflow/user.svg"
                    class="mr-1"
                    alt=""
                  />
                  {{ vendor.name }}
                </div>
                <div style="width: 30%" class="text-truncate pr-1">
                  {{ vendor.email }}
                </div>
                <div style="width: 30%" class="text-truncate pr-1">
                  {{
                    vendor.customFields.Location
                      ? vendor.customFields.Location
                      : "-"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
    <div
      class="
        acs-paginaTion-new
        d-flex
        justify-content-between
        align-items-center
      "
    >
      <div class="d-flex">
        <span class="acs-gotopage-text p-1 mr-2">Go to page</span>
        <b-form-input
          v-model="goToPage"
          @keyup.enter="
            goToPage === null || goToPage == '' || iscontainsNumber
              ? goToPages(goToPage)
              : ''
          "
          @keypress="NumbersOnly"
          type="text"
          class="acs-pagination-num"
        ></b-form-input>
        <div class="acs-pagination-addbtn">
          <span
            @click="
              goToPage === null || goToPage == '' || !iscontainsNumber
                ? ''
                : goToPages(goToPage)
            "
            :class="
              goToPage === null || goToPage == '' || !iscontainsNumber
                ? 'disableDeleteIcon pl-3 mt-1'
                : 'pointer pl-3 mt-1'
            "
          >
            <img src="../../../assets/panelist/page_arrow.svg" alt />
          </span>
        </div>
      </div>

      <div class="pagination">
        <b-pagination
          v-model.number="currentPage"
          @input="getVendors(), (goToPage = null)"
          :total-rows="total"
          :per-page="pageCount"
          align="center"
          first-number
          last-number
        >
          <template #prev-text>
            <span>
              <img src="../../../assets/img/accessconnew/pageleft.svg" alt />
            </span>
          </template>
          <template #next-text>
            <span>
              <img src="../../../assets/img/accessconnew/pageright.svg" alt />
            </span>
          </template>
        </b-pagination>
      </div>
      <div class="d-flex align-items-center">
        <PageInput :pagecount="pageCount" @update-value="updatePage" />

        <div class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end">
          Showing :

          <div
            class="text-truncate ml-2 results-individual-width"
            v-if="pageStart > total"
          >
            0
          </div>
          <div class="text-truncate ml-2 results-individual-width">
            {{ pageStart }}
          </div>
          <div class="text-truncate results-individual-width">-</div>
          <div class="text-truncate results-individual-width">
            {{ pageEnd }}
          </div>
          <div class="text-truncate ml-1 results-individual-width">of</div>
          <div class="text-truncate ml-1 results-individual-width">
            {{ total }}
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end p-3 bluebtn">
      <b-button @click="closeModal" class="acs-cancelBtn-modal pointer mr-3"
        >Cancel</b-button
      >

      <b-button class="acs-addBtn-modal pointer" @click="assignVendor"
        >Assign</b-button
      >
    </div>
  </b-modal>
</template>

<script>
import PageInput from "../../../components/InputComponents/PaginationInput.vue";
import { NumbersOnly } from "../../../controllers/Candidate/helpers";
import { getVendor } from "../../../utils/apiFunctions";

export default {
  name: "AllocateVendor",
  props: {
    showAllocateVendor: Boolean,
    vendorsData: Array,
  },
  data() {
    return {
      // NUMBERS
      total: 0,
      currentPage: 1,
      pageCount: 10,
      goToPage: null,
      order: -1,

      // STRINGS
      pageStart: "",
      pageEnd: "",
      searchQuery: "",
      sortBy: "createdAt",

      // ARRAYS
      vendorData: [],
      vendorSelected: [],
      selVendorDetails: [],

      // BOOLEAN
      showVendorLoader: false,
      selectAllChecked: false,
    };
  },
  components: {
    PageInput,
  },
  async mounted() {
    // Await for populateVendorData() before calling getVendors()
    await this.populateVendorData();
    this.getVendors();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageCount);
    },
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
  },
  methods: {
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    goToPages(index) {
      this.currentPage = Math.min(Math.max(1, index), this.totalPages);
      this.goToPage = null;
      this.getVendors();
    },
    closeModal() {
      this.$emit("hide-modal");
    },
    updatePage(value) {
      this.pageCount = value;
      this.currentPage = 1;
      this.getVendors();
    },
    populateVendorData() {
      if (this.vendorsData.length !== 0) {
        this.vendorData = this.vendorsData.forEach((vendor) => {
          // Push selected vendor information into vendorSelected array
          this.vendorSelected.push({
            vendorID: vendor.vendorID,
            vendorUserID: vendor.vendorUserID,
            email: vendor.email,
            name: vendor.name,
          });
        });
      }
    },
    isSelected(vendor) {
      return this.vendorSelected?.some((v) => v.vendorID === vendor.vendorID);
    },
    selectAllVendors() {
      for (let i in this.vendorData) {
        if (
          this.selectAllChecked &&
          this.vendorSelected.filter(
            (value) => value == this.vendorData[i].vendorID
          ).length === 0
        ) {
          this.vendorSelected.push({
            vendorID: this.vendorData[i].vendorID,
            vendorUserID: this.vendorData[i].vendorUserID,
            email: this.vendorData[i].email,
            name: this.vendorData[i].name,
          });
        } else {
          this.vendorSelected.splice(
            this.vendorSelected.indexOf(this.vendorData[i].vendorID)
          );
        }
      }
      this.updateSelectAllStatus();
    },
    updateSelectAllStatus() {
      const containsAll =
        this.vendorData.length > 0 &&
        this.vendorData.every((element) =>
          this.vendorSelected.some(
            (selected) => selected.vendorID === element.vendorID
          )
        );

      this.selectAllChecked = containsAll;

      // Remove duplicates from vendorSelected
      const uniqueVendors = [];
      const seenIDs = new Set();
      for (const vendor of this.vendorSelected) {
        if (!seenIDs.has(vendor.vendorID)) {
          uniqueVendors.push(vendor);
          seenIDs.add(vendor.vendorID);
        }
      }
      this.vendorSelected = uniqueVendors;
    },
    checkSelectAll() {
      if (this.vendorData.length === 0) {
        this.selectAllChecked = false;
        return;
      }
      this.selectAllChecked = this.vendorData.every((record) =>
        this.vendorSelected.some((value) => value.vendorID === record.vendorID)
      );
    },
    async getVendors() {
      this.showVendorLoader = true;
      try {
        let payload = {
          type: 1,
          searchQuery: this.searchQuery,
          sortColumn: this.sortBy,
          sortOrder: this.order,
          page: this.currentPage - 1,
          count: this.pageCount,
        };
        const response = await getVendor(payload);
        if (response.status == 200) {
          this.vendorData = response.data.data.data;
          this.total = response.data.data.total;
          this.pageStart = response.data.data.pageStart;
          this.pageEnd = response.data.data.pageEnd;
          this.checkSelectAll();
        }
        const element = document.getElementById("top1");
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.showVendorLoader = false;
      }
    },
    assignVendor() {
      this.$emit("assign-vendor", this.vendorSelected);
    },
  },
};
</script>

<style scoped>
.kanban-exc-main-table {
  height: calc(100vh - 420px);
}

.kanban-exc-table-row {
  width: 100%;
  position: relative;
  border-radius: 5px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  font-family: "lato", sans-serif;
  padding: 10px;
  margin: 8px 0px;
}

.kanban-exc-table-row:hover {
  background: #e7e8f5;
}

.vendor-exc-table-body {
  min-width: 1000px;
  max-width: 100%;
  overflow-y: auto;
  height: calc(100vh - 460px);
}
</style>
